let params = {}

const onFilterChange = (e) => {
    fetchData(setParams(params, e.target.name, e.target.value))
}

const changeFilter = (button) => {
    const filterName = button.getAttribute('data-for-filter-name'),
          e = new Event('change');

    let filter, option, select, options = [];

    if (filterName) {
        filter = document.querySelector(`[name=${filterName}]`);
    }

    if (filter) {
        options = [...filter.options];
        option = options.find(o => o.text === button.innerText);
    }

    if (option) {
        option.selected = true;
        select = option.closest('.js_onCareersFilterChange');
    }

    if (select) {
        select.dispatchEvent(e);
    }
}

const initFilterButtons = () => {
    const filterButtons = [...document.querySelectorAll('.js_careersFilterButton')];

    filterButtons.forEach(button => button.addEventListener('click', e => changeFilter(button)));
}

const fetchData = (params) => {
    $("#loadingOverlay").show()

    $.ajax({
        type: 'get',
        url: '/sites/petervardy/templates/ajax/careers-landing/filter.php',
        dataType: 'json',
        data: {
            ajax: true,
            ...params
        },
        success: function (response) {
            if (response.items.length > 0) {
                $('.js_careersAllGrid').html(response.items).removeClass('careersGrid--hide');
                $('.js_noCareersFound').addClass('noCareersFound--hide');

                initFilterButtons();
            } else {
                $('.js_careersAllGrid').html(response.items).addClass('careersGrid--hide');
                $('.js_noCareersFound').removeClass('noCareersFound--hide');
            }

            $('.js_careersFilterBar__count__value').html(response.total);
        }
    }).done(function () {
        $("#loadingOverlay").hide()
    })
}

const setParams = (params, key, value) => {
    if (value) {
        params[key] = value

        return params
    }

    delete params[key]

    return params
}

$(document).ready(function () {
    'use strict';

    const filterEls = document.querySelectorAll('.js_onCareersFilterChange')

    filterEls.forEach((f) => f.addEventListener('change', onFilterChange))
    initFilterButtons();
})
